import React from 'react';
import SvgIcon from './SvgIcon';

/**
 * @param {FF.SvgIcon} props
 */
export default function ChefsKnifeIcon(props) {
  return (
    <SvgIcon type="presentation" viewBox="0 0 18 18" {...props}>
      <path
        d="m5.288 10.875c-.311 0-.563-.252-.563-.563 0-.31.252-.562.563-.562.31 0 .562.252.562.563 0 .31-.252.562-.562.562zm-3.6 1.65c-.311 0-.563-.252-.563-.562 0-.311.252-.563.562-.563.311 0 .563.252.563.563 0 .31-.252.562-.563.562zm5.301-3.76-6.989 2.56s.944 1.969 2.247 1.753c.966-.264 1.011-1.73 1.236-1.825.135-.072.607.816 2.045.168 1.199-.582 1.414-1.536 1.453-1.88l.84 2.672 5.415-2.473c3.236-1.465 4.764-4.828 4.764-4.828l-11.01 3.853z"
        fillRule="evenodd"
      />
    </SvgIcon>
  );
}
